const AccountingEndpoint = {
  index (range, start_date, end_date) {
    return {
      url: `/accountings?range=${range}&timestamp=${Date.now()}&start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
    }
  },
  tips (range, start_date, end_date) {
    return {
      url: `/tip_totals?range=${range}&timestamp=${Date.now()}&start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
    }
  },
  time_series (range, start_date, end_date) {
    return {
      url: `/time_series?range=${range}&timestamp=${Date.now()}&start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
    }
  },
  totals (range, start_date, end_date) {
    return {
      url: `/accountings/totals?range=${range}&timestamp=${Date.now()}&start_date=${start_date}&end_date=${end_date}`,
      method: 'GET',
    }
  }
}

export default AccountingEndpoint



// WEBPACK FOOTER //
// ./src/persistence/AccountingEndpoint.js